// Press coverage of ClearWay. Sourced from the PR Newswire pickup report for
// the 28 August 2026 release, plus pieces found by web search. Shared by the
// homepage "Featured in" strip and the /press page so the two never drift.
//
// `featured` outlets are the national/international brands and wire agencies
// that carried the release in full. `editorial` pieces are the only ones
// written in an outlet's own words rather than copied from the release.

export const PRESS_RELEASE_DATE = '28 August 2026';

export const PRESS_RELEASE_URL =
  'https://www.prnewswire.com/in/news-releases/clearway-mobility-introduces-obstacle-detection-device-to-be-added-to-the-standard-white-cane-used-by-visually-impaired-people-302862707.html';

export const PRESS_RELEASE_HEADLINE =
  'ClearWay Mobility introduces obstacle detection device to be added to the standard white cane used by visually impaired people';

export const PRESS_STATS = [
  { value: '160', label: 'Outlets carried the story' },
  { value: '13', label: 'National & international brands' },
  { value: '128M', label: 'Combined monthly audience' },
];

// Ordered by reputation, most notable first. `kind` is shown as a caption.
export const FEATURED_OUTLETS = [
  {
    name: 'The Hindu',
    kind: 'National newspaper',
    href: 'https://www.thehindu.com/brandhub/pr-release/clearway-mobility-introduces-obstacle-detection-device-to-be-added-to-the-standard-white-cane-used-by-visually-impaired-people/article71400032.ece',
  },
  {
    name: 'India Today',
    kind: 'National news magazine',
    href: 'https://www.indiatoday.in/pr-newswire?rkey=20260828EN35913&filter=4315',
  },
  {
    name: 'Yahoo Finance',
    kind: 'Global finance portal',
    href: 'https://finance.yahoo.com/technology/articles/clearway-mobility-introduces-obstacle-detection-101600314.html',
  },
  {
    name: 'Business Standard',
    kind: 'National business daily',
    href: 'https://www.business-standard.com/content/press-releases-ani/clearway-mobility-introduces-obstacle-detection-device-to-be-added-to-the-standard-white-cane-used-by-visually-impaired-people-126082800922_1.html',
  },
  {
    name: 'The Hindu BusinessLine',
    kind: 'National business daily',
    href: 'https://www.thehindubusinessline.com/brandhub/pr-release/clearway-mobility-introduces-obstacle-detection-device-to-be-added-to-the-standard-white-cane-used-by-visually-impaired-people/article71400034.ece',
  },
  {
    name: 'Business Today',
    kind: 'National business magazine',
    href: 'https://www.businesstoday.in/prnewswire/?rkey=20260828EN35913&filter=2418',
  },
  {
    name: 'ThePrint',
    kind: 'National digital news',
    href: 'https://theprint.in/ani-press-releases/clearway-mobility-introduces-obstacle-detection-device-to-be-added-to-the-standard-white-cane-used-by-visually-impaired-people/3027640/',
  },
  {
    name: 'The Tribune',
    kind: 'National newspaper',
    href: 'https://www.tribuneindia.com/news/business/clearway-mobility-introduces-obstacle-detection-device-to-be-added-to-the-standard-white-cane-used-by-visually-impaired-people',
  },
  {
    name: 'Press Trust of India',
    kind: 'National wire agency',
    href: 'https://www.ptinews.com/press-release/clearway-mobility-introduces-obstacle-detection-device-to-be-added-to-the-standard-white-cane-used-by-visually-impaired-people/4012544',
  },
  {
    name: 'ANI',
    kind: 'National wire agency',
    href: 'https://www.aninews.in/news/business/clearway-mobility-introduces-obstacle-detection-device-to-be-added-to-the-standard-white-cane-used-by-visually-impaired-people20260828161836',
  },
  {
    name: 'United News of India',
    kind: 'National wire agency',
    href: 'http://uniindia.com/clearway-mobility-introduces-obstacle-detection-device-to-be-added-to-the-standard-white-cane-used-by-visually-impaired-people/prnewswire/news/3957083.html',
  },
  {
    name: 'PR Newswire',
    kind: 'Original release',
    href: PRESS_RELEASE_URL,
  },
  {
    name: 'DailyHunt',
    kind: 'News aggregator',
    href: 'https://m.dailyhunt.in/news/india/english/pr%20newswire%20english-epaper-prnswe/clearway%20mobility%20introduces%20obstacle%20detection%20device%20to%20be%20added%20to%20the%20standard%20white%20cane%20used%20by%20visually%20impaired%20people-newsid-n724891545',
  },
];

// Independent write-ups, strongest first.
export const EDITORIAL_COVERAGE = [
  {
    outlet: 'ElectronicsForU',
    headline: 'Electronics Add Intelligence to White Canes',
    date: '1 September 2026',
    summary:
      'A technical look at the two sensing zones, haptic alerts and location tracking, positioning ClearWay as a hardware-first alternative to camera- and AI-based canes.',
    href: 'https://www.electronicsforu.com/news/electronics-add-intelligence-to-white-canes',
  },
  {
    outlet: 'BriefGlance',
    headline: 'A Clearer Path: How a Teen’s Vision is Upgrading the Humble White Cane',
    date: '28 August 2026',
    summary:
      'A long-form piece placing ClearWay in the wider market for electronic mobility aids and comparing it with existing smart canes.',
    href: 'https://briefglance.com/articles/a-clearer-path-how-a-teens-vision-is-upgrading-the-humble-white-cane',
  },
  {
    outlet: 'StartupLanes',
    headline:
      'Mumbai Student Develops Smart Attachment for Standard White Cane to Aid Visually Impaired',
    date: 'September 2026',
    summary:
      'A startup-news write-up from an Indian angel network on the founder story and the decision to build an add-on for the cane people already own.',
    href: 'https://www.startuplanes.com/post/',
  },
];

// Short list for the homepage strip: the outlets a visitor recognises at a glance.
export const HOMEPAGE_OUTLETS = FEATURED_OUTLETS.filter((o) =>
  [
    'The Hindu',
    'India Today',
    'Yahoo Finance',
    'Business Standard',
    'The Hindu BusinessLine',
    'Business Today',
    'ThePrint',
    'The Tribune',
    'Press Trust of India',
    'ANI',
  ].includes(o.name)
);
